export default __webpack_public_path__ + "b2a4b2ace5c14156a3ec128a33c6d4c4.jpg";